import { IconProps } from "@/models/Icon";

export function BarteIcon({ 
    size = 25, 
    color = "#000", 
}: IconProps) {
    return(
        <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                d="M19.5944 12.736C19.3665 12.388 18.9632 12.18 18.5149 12.18H15.2831L19.0747 3.65442C19.2459 3.2694 19.2106 2.84436 18.9772 2.48784C18.7092 2.07796 18.2328 1.83301 17.704 1.83301H11.2716C10.2786 1.83301 9.40138 2.36355 9.03648 3.18451L5.48429 11.1711C5.33443 11.5076 5.3655 11.8799 5.56958 12.1915C5.80229 12.548 6.21532 12.7603 6.67404 12.7603H9.81502L5.93814 21.4756C5.78462 21.8212 5.8163 22.2026 6.02525 22.5221C6.26466 22.8884 6.68866 23.1066 7.16017 23.1066H13.7266C14.8098 23.1066 15.7662 22.5288 16.164 21.6345L19.6772 13.734C19.824 13.4042 19.7936 13.0404 19.5937 12.7354L19.5944 12.736ZM6.67343 12.18C6.4127 12.18 6.18303 12.066 6.05815 11.875C6.00271 11.7901 5.92413 11.6173 6.01794 11.4063L9.56952 3.41916C9.83696 2.81768 10.5211 2.41387 11.271 2.41387H15.8655C16.1262 2.41387 16.3559 2.52786 16.4808 2.71885C16.5362 2.80374 16.6148 2.97654 16.5216 3.18755L12.9913 11.1256C12.7111 11.7562 11.9941 12.18 11.2076 12.18H6.67343ZM19.1442 13.4994L15.631 21.3998C15.3312 22.0735 14.5661 22.5264 13.7266 22.5264H9.23812C8.98835 22.5264 8.76722 22.4172 8.64782 22.2341C8.59482 22.1535 8.51989 21.988 8.60944 21.7873L12.2896 13.5121C12.4894 13.0622 13.0035 12.7603 13.5676 12.7603H18.5155C18.7653 12.7603 18.9864 12.8694 19.1058 13.0525C19.1588 13.1331 19.2337 13.2987 19.1448 13.4994H19.1442Z" 
                fill={color}
            />
        </svg>
    )
}






